"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteMapLayerForm = void 0;
var React = require("react");
var SiteMapLayerService_1 = require("../../../../services/SiteMapLayerService");
var stateless_forms_1 = require("../../../logistics/forms/stateless_forms");
var immer_1 = require("immer");
var buttons_1 = require("../../../buttons");
function getSiteMapLayerFormFields(layer) {
    return [
        {
            name: "name",
            label: gettext("Name"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            value: layer.name,
        },
        {
            name: "icon",
            label: gettext("Icon"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.SELECT,
            value: layer.icon,
            options: SiteMapLayerService_1.layer_icon_options,
        },
        {
            name: "color",
            label: gettext("Color"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.SELECT,
            value: layer.color,
            options: SiteMapLayerService_1.layer_color_options,
        },
    ];
}
var SiteMapLayerForm = function (_a) {
    var site_id = _a.site_id, layer = _a.layer, onSave = _a.onSave, onDelete = _a.onDelete;
    var initial_data = {
        id: (layer === null || layer === void 0 ? void 0 : layer.id) || 0,
        site: (layer === null || layer === void 0 ? void 0 : layer.site) || site_id,
        name: (layer === null || layer === void 0 ? void 0 : layer.name) || gettext("Layer"),
        color: (layer === null || layer === void 0 ? void 0 : layer.color) || "#7D83FF",
        icon: (layer === null || layer === void 0 ? void 0 : layer.icon) || SiteMapLayerService_1.LayerIcon.PIN,
    };
    var _b = __read(React.useState(initial_data), 2), layer_data = _b[0], setLayerData = _b[1];
    React.useEffect(function () {
        if (layer)
            setLayerData(layer);
        else
            setLayerData(initial_data);
    }, [layer === null || layer === void 0 ? void 0 : layer.id]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement("h3", null, gettext("Layer Information")),
                React.createElement(stateless_forms_1.SimpleForm, { fields: getSiteMapLayerFormFields(layer_data), onUpdate: function (name, value) {
                        return setLayerData((0, immer_1.default)(layer_data, function (draft) {
                            draft[name] = value;
                        }));
                    }, valuesObject: layer_data }))),
        React.createElement("div", { className: "row mt-2" },
            React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () { return onSave(layer_data); } }, gettext("Save")),
            location && (React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () { return onDelete(layer_data); } }, gettext("Delete"))))));
};
exports.SiteMapLayerForm = SiteMapLayerForm;
